import { useEffect } from "react";
import * as D from "@radix-ui/react-dialog";
import { X } from "lucide-react";

export const LuxDialog = ({ open, onClose, title, eyebrow, children, wide = false, testid, dark = false }) => {
  useEffect(() => {
    if (open) window.__lenis?.stop();
    else window.__lenis?.start();
    return () => window.__lenis?.start();
  }, [open]);

  return (
    <D.Root open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-[80] bg-[#21170F]/70 backdrop-blur-[6px] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 duration-500" />
        <D.Content data-testid={testid} data-lenis-prevent
          className={`fixed inset-x-0 bottom-0 top-auto z-[90] max-h-[92svh] overflow-y-auto sm:inset-auto sm:left-1/2 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 w-full ${wide ? "sm:max-w-5xl" : "sm:max-w-3xl"} ${dark ? "bg-[#21170F] text-[#F8F3E9]" : "bg-[#F8F3E9] text-[#26231F]"} border-t sm:border border-[#B18A4A]/40 shadow-[0_40px_120px_-20px_rgba(33,23,15,.55)] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-bottom-8 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 duration-500`}>
          <div className="sticky top-0 z-10 flex items-start justify-between gap-6 border-b border-[#B18A4A]/25 bg-inherit px-6 py-5 sm:px-10">
            <div>
              {eyebrow && <p className="eyebrow">{eyebrow}</p>}
              <D.Title className="font-serif-lux mt-2 text-3xl leading-tight sm:text-4xl">{title}</D.Title>
            </div>
            <D.Close data-testid={`${testid}-close`} aria-label="Close dialog"
              className="mt-1 grid h-11 w-11 shrink-0 place-items-center rounded-full border border-[#B18A4A]/40 transition-colors duration-300 hover:bg-[#B18A4A] hover:text-white">
              <X className="h-4 w-4" strokeWidth={1.5} />
            </D.Close>
          </div>
          <D.Description className="sr-only">{eyebrow} {title}</D.Description>
          <div className="px-6 py-8 sm:px-10 sm:py-10">{children}</div>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
};

export const SpecRow = ({ label, value }) => (
  <div className="flex items-baseline justify-between gap-6 border-b border-[#B18A4A]/20 py-4">
    <dt className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#8C6A3C]">{label}</dt>
    <dd className="text-right font-serif-lux text-xl">{value}</dd>
  </div>
);
